
import styled from "styled-components"
import { updateVehicle } from "../../../features/joblist/jobListSlice";
import { useDispatch } from "react-redux";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    margin: 0 auto;
    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }
`

const TextInput = ({data, keyData, name, labelText, inputWidth}) => {

    const dispatch = useDispatch()

    const handleSearch = (event) => {
        const term = event.target.value;
        dispatch(updateVehicle({ keyData, value: term}) );
    };

  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <input autocomplete="off" type="text" id={"text"} onChange={handleSearch} value={data} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default TextInput